/* KrakenTheMeta dashboard — Collection: every card the user owns, binders to group them, and the
 * add / import / export / clear flows. The AI builder reads these same savedCards when a user
 * builds "only from my collection".
 */
(function () {
  "use strict";

  var KD = window.KD, S = KD.state, D = KD.data, esc = KD.esc;
  var CHUNK = 120;
  var TYPES = ["Creature", "Instant", "Sorcery", "Artifact", "Enchantment", "Planeswalker", "Land", "Battle"];
  var COLOR_NAME = { W: "White", U: "Blue", B: "Black", R: "Red", G: "Green", C: "Colorless" };

  var st = { q: "", binder: "", sort: "name", type: "", colors: new Set(), view: viewPref(), shown: 0, list: [] };
  var root = null, io = null, qT = null;

  function viewPref() { try { return localStorage.getItem("kd_coll_view") === "list" ? "list" : "grid"; } catch (e) { return "grid"; } }
  function mounted() { return !!root && document.body.contains(root); }
  function $(s) { return root ? KD.$(s, root) : null; }
  function qtyOf(c) { return parseInt(c.quantity, 10) || 0; }
  function priceOf(c) { var p = parseFloat(c.price); return isNaN(p) ? 0 : p; }
  function nameCmp(a, b) { return String(a.name || "").localeCompare(String(b.name || "")); }
  function inBinder(c, id) { return (c.binderIds || []).indexOf(id) !== -1; }
  function copiesIn(id) { return (S.collection || []).filter(function (c) { return inBinder(c, id); }).reduce(function (t, c) { return t + qtyOf(c); }, 0); }

  KD.collection = {
    addCards: function () { openAdd(); },
    importList: function () { openImport(); }
  };

  // ================================================================ route

  KD.routes.collection = function (view) {
    view.innerHTML = '<div data-coll>' +
      '<div class="vhead"><div class="vhead__text"><p class="depth-tag">Your vault</p><h2>Collection</h2><p>Every card you own, in one place. The Kraken can build decks from it.</p></div>' +
        '<div class="vhead__actions">' +
          '<button class="btn btn--ghost" type="button" data-c="import">' + KD.icon("download") + "<span>Import</span></button>" +
          '<button class="btn btn--lure" type="button" data-c="add">' + KD.icon("plus") + "<span>Add cards</span></button>" +
          '<button class="iconbtn iconbtn--line" type="button" data-c="more" aria-label="More collection options" title="More">' + KD.icon("dots") + "</button>" +
        "</div></div>" +
      '<div class="tiles">' +
        '<div class="tile"><b data-t="cards">…</b><span>Cards</span></div>' +
        '<div class="tile"><b data-t="unique">…</b><span>Unique</span></div>' +
        '<div class="tile"><b data-t="value">…</b><span>Est. value</span></div>' +
        '<div class="tile"><b data-t="binders">…</b><span>Binders</span></div>' +
      "</div>" +
      "<div data-cta></div>" +
      '<div class="chips mt-16" data-binders></div>' +
      '<div class="toolbar mt-16" data-toolbar>' +
        '<label class="inputwrap">' + KD.icon("search") + '<input class="input" type="search" data-q placeholder="Search your cards" value="' + esc(st.q) + '" aria-label="Search your collection"></label>' +
        '<select class="select" style="width:auto" data-type aria-label="Card type"><option value="">Any type</option>' +
          TYPES.map(function (t) { return '<option value="' + t.toLowerCase() + '">' + t + "</option>"; }).join("") + "</select>" +
        '<select class="select" style="width:auto" data-sort aria-label="Sort cards"><option value="name">Name</option><option value="price">Price</option><option value="value">Total value</option><option value="qty">Most copies</option></select>' +
        '<div class="seg" role="tablist" aria-label="Show cards as">' +
          '<button type="button" role="tab" data-view="grid">' + KD.icon("grid") + '<span class="hide-sm">Cards</span></button>' +
          '<button type="button" role="tab" data-view="list">' + KD.icon("list") + '<span class="hide-sm">List</span></button>' +
        "</div>" +
      "</div>" +
      '<div class="colors mb-12" role="group" aria-label="Filter by color" data-colorbar>' + ["W", "U", "B", "R", "G", "C"].map(function (c) {
        return '<button type="button" data-color="' + c + '" title="' + COLOR_NAME[c] + '" aria-pressed="false">' + KD.mana("{" + c + "}") + "</button>";
      }).join("") + "</div>" +
      '<div class="cgrid" data-grid>' + skeletons() + "</div>" +
      '<div class="coll-more" data-sentinel></div>' +
    "</div>";
    root = KD.$("[data-coll]", view);
    KD.$("[data-type]", root).value = st.type;
    KD.$("[data-sort]", root).value = st.sort;
    syncViewSeg();
    syncColors();
    wire();
    D.loadCollection(!S.collectionLoaded).then(function () { if (mounted()) paint(); }).catch(function (e) {
      console.error(e);
      if (mounted()) $("[data-grid]").innerHTML = loadError();
    });
  };

  function skeletons() { var h = ""; for (var i = 0; i < 12; i++) h += '<div class="skel" style="aspect-ratio:488/680"></div>'; return h; }
  function loadError() {
    return '<div class="empty" style="grid-column:1/-1">' + KD.icon("alert") + "<h3>Couldn't load your collection</h3><p>Check your connection and refresh the page.</p></div>";
  }

  function wire() {
    root.addEventListener("click", function (e) {
      var t = e.target, el;
      if ((el = t.closest("[data-c]"))) {
        var c = el.dataset.c;
        if (c === "import") openImport();
        else if (c === "add") openAdd();
        else if (c === "more") moreMenu(el);
        else if (c === "build") KD.create.open({ mode: "ai", useCollection: true });
        return;
      }
      if ((el = t.closest("[data-binder]"))) { st.binder = el.dataset.binder; paint(); return; }
      if (t.closest("[data-binders-manage]")) { openBinders(); return; }
      if ((el = t.closest("[data-view]"))) {
        st.view = el.dataset.view;
        try { localStorage.setItem("kd_coll_view", st.view); } catch (err) { /* ignore */ }
        syncViewSeg(); paintGrid();
        return;
      }
      if ((el = t.closest("[data-color]"))) {
        var col = el.dataset.color;
        if (st.colors.has(col)) st.colors.delete(col); else st.colors.add(col);
        syncColors(); paintGrid();
        return;
      }
      if ((el = t.closest("[data-cid]"))) {
        var card = (S.collection || []).find(function (x) { return x.id === el.dataset.cid; });
        if (card) openCard(card);
        return;
      }
      if (t.closest("[data-more-cards]")) moreCards();
    });
    KD.$("[data-q]", root).addEventListener("input", function (e) {
      st.q = e.target.value;
      clearTimeout(qT);
      qT = setTimeout(paintGrid, 140);
    });
    KD.$("[data-type]", root).addEventListener("change", function (e) { st.type = e.target.value; paintGrid(); });
    KD.$("[data-sort]", root).addEventListener("change", function (e) { st.sort = e.target.value; paintGrid(); });
  }

  function syncViewSeg() {
    KD.$$("[data-view]", root).forEach(function (b) { b.setAttribute("aria-selected", String(b.dataset.view === st.view)); });
  }
  function syncColors() {
    KD.$$("[data-color]", root).forEach(function (b) {
      var on = st.colors.has(b.dataset.color);
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", String(on));
    });
  }

  // ================================================================ paint

  function scoped() {
    var all = S.collection || [];
    if (st.binder === "__unfiled__") return all.filter(function (c) { return !(c.binderIds && c.binderIds.length); });
    if (st.binder) return all.filter(function (c) { return inBinder(c, st.binder); });
    return all;
  }

  function paint() {
    if (!mounted()) return;
    if (st.binder && st.binder !== "__unfiled__" && !S.binders.some(function (b) { return b.id === st.binder; })) st.binder = "";
    paintTiles();
    paintBinders();
    paintCta();
    paintGrid();
  }

  function paintTiles() {
    var t = D.collectionTotals(scoped());
    var set = function (k, v) { var el = $('[data-t="' + k + '"]'); if (el) el.textContent = v; };
    set("cards", KD.fmt(t.cards));
    set("unique", KD.fmt(t.unique));
    set("value", KD.money(t.value));
    set("binders", KD.fmt(S.binders.length));
  }

  function paintBinders() {
    var host = $("[data-binders]");
    if (!(S.collection || []).length && !S.binders.length) { host.innerHTML = ""; return; }
    var chip = function (id, label, n) {
      return '<button type="button" class="chip' + (st.binder === id ? " is-on" : "") + '" data-binder="' + esc(id) + '">' + label + (n != null ? " <small>" + KD.fmt(n) + "</small>" : "") + "</button>";
    };
    host.innerHTML = chip("", "All cards") +
      S.binders.map(function (b) { return chip(b.id, KD.icon("folder") + esc(b.name), copiesIn(b.id)); }).join("") +
      (S.binders.length ? chip("__unfiled__", "Unfiled") : "") +
      '<button type="button" class="chip" data-binders-manage>' + KD.icon(S.binders.length ? "gear" : "plus") + (S.binders.length ? "Manage binders" : "New binder") + "</button>";
  }

  function paintCta() {
    var host = $("[data-cta]");
    var n = (S.collection || []).length;
    host.innerHTML = n ? '<div class="strip strip--info">' +
      '<div class="strip__text"><b>Build from these cards</b><p>The Kraken can build a deck using only cards you own, from the whole collection or a single binder.</p></div>' +
      '<button class="btn btn--lure btn--sm" type="button" data-c="build">' + KD.icon("sparkle") + "<span>Build from my collection</span></button></div>" : "";
  }

  function filtered() {
    var q = st.q.trim().toLowerCase();
    var list = scoped().filter(function (c) {
      if (q && String(c.name || "").toLowerCase().indexOf(q) === -1) return false;
      if (st.type && String(c.types || "").toLowerCase().indexOf(st.type) === -1) return false;
      if (st.colors.size) {
        var cols = c.colors || [];
        if (!(st.colors.has("C") && !cols.length) && !cols.some(function (x) { return st.colors.has(x); })) return false;
      }
      return true;
    });
    list.sort(function (a, b) {
      if (st.sort === "price") return priceOf(b) - priceOf(a) || nameCmp(a, b);
      if (st.sort === "value") return priceOf(b) * qtyOf(b) - priceOf(a) * qtyOf(a) || nameCmp(a, b);
      if (st.sort === "qty") return qtyOf(b) - qtyOf(a) || nameCmp(a, b);
      return nameCmp(a, b);
    });
    return list;
  }

  function paintGrid() {
    if (!mounted()) return;
    var host = $("[data-grid]"), sentinel = $("[data-sentinel]");
    if (io) { io.disconnect(); io = null; }
    sentinel.innerHTML = "";
    if (!S.collectionLoaded) { host.className = ""; host.innerHTML = loadError(); return; }
    if (!(S.collection || []).length) {
      host.className = "";
      host.innerHTML = '<div class="empty panel">' + KD.icon("box") + "<h3>Your vault is empty</h3>" +
        "<p>Add the cards you own and the Kraken can build decks from them, so you only brew with what's already in your binder.</p>" +
        '<div class="row row--wrap" style="justify-content:center">' +
          '<button class="btn btn--ghost" type="button" data-c="import">' + KD.icon("download") + "Import a list</button>" +
          '<button class="btn btn--lure" type="button" data-c="add">' + KD.icon("plus") + "Add cards</button></div></div>";
      return;
    }
    st.list = filtered();
    st.shown = 0;
    if (!st.list.length) {
      host.className = "";
      var binderOnly = st.binder && st.binder !== "__unfiled__" && !st.q && !st.type && !st.colors.size;
      host.innerHTML = binderOnly
        ? '<div class="empty">' + KD.icon("folder") + "<h3>Nothing in this binder yet</h3><p>Open any card and tick this binder to file it here.</p></div>"
        : '<div class="empty">' + KD.icon("search") + "<p>No cards match that.</p></div>";
      return;
    }
    host.className = st.view === "list" ? "panel clist" : "cgrid";
    host.innerHTML = "";
    moreCards();
  }

  // Big collections render in chunks as you scroll.
  function moreCards() {
    var host = $("[data-grid]"), sentinel = $("[data-sentinel]");
    if (!host) return;
    var slice = st.list.slice(st.shown, st.shown + CHUNK);
    host.insertAdjacentHTML("beforeend", slice.map(st.view === "list" ? rowHTML : tileHTML).join(""));
    st.shown += slice.length;
    if (st.shown < st.list.length) {
      sentinel.innerHTML = '<button class="btn btn--ghost btn--sm" type="button" data-more-cards>Show more (' + KD.fmt(st.list.length - st.shown) + ")</button>";
      if ("IntersectionObserver" in window) {
        if (!io) io = new IntersectionObserver(function (entries) { if (entries.some(function (x) { return x.isIntersecting; })) moreCards(); }, { rootMargin: "700px 0px" });
        io.unobserve(sentinel);
        io.observe(sentinel); // observe() reports the current state, so a still-visible sentinel loads the next chunk too
      }
    } else {
      sentinel.innerHTML = "";
      if (io) { io.disconnect(); io = null; }
    }
  }

  function tileHTML(c) {
    var img = KD.safeUrl(c.imageUrl), filed = c.binderIds && c.binderIds.length, p = priceOf(c);
    return '<button class="ccard" type="button" data-cid="' + esc(c.id) + '" aria-label="' + esc(qtyOf(c) + " " + c.name) + '">' +
      '<span class="ccard__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '<span class="noimg">' + esc(c.name) + "</span>") +
        '<span class="ccard__qty">' + qtyOf(c) + "×</span>" +
        (filed ? '<span class="ccard__bind" title="Filed in a binder">' + KD.icon("folder") + "</span>" : "") + "</span>" +
      '<span class="ccard__name">' + esc(c.name) + "</span>" +
      '<span class="ccard__price">' + (p ? "$" + p.toFixed(2) : "–") + "</span></button>";
  }
  function rowHTML(c) {
    var p = priceOf(c);
    return '<button type="button" class="drow" data-cid="' + esc(c.id) + '">' +
      '<span class="drow__qty">' + qtyOf(c) + "×</span>" +
      '<span class="drow__name">' + (c.binderIds && c.binderIds.length ? KD.icon("folder") : "") + "<span>" + esc(c.name) + "</span></span>" +
      '<span class="drow__cost">' + KD.mana(String(c.manaCost || "").split("//")[0]) + "</span>" +
      '<span class="drow__price">' + (p ? "$" + p.toFixed(2) : "") + "</span></button>";
  }

  // ================================================================ one card

  function openCard(c) {
    var changed = false, chain = Promise.resolve();
    var s = KD.sheet({
      title: esc(c.name), size: "lg",
      onClose: function () { if (changed) paint(); },
      body: '<div class="cardx">' + KD.cardx.img(c.imageUrl, c.name) + '<div class="cardx__info">' + KD.cardx.info(c) +
        '<div class="row row--wrap"><span class="label">Copies owned</span><div class="qtyctl" role="group" aria-label="Copies owned">' +
          '<button class="iconbtn iconbtn--sm" type="button" data-q="-1" aria-label="One fewer">' + KD.icon("minus") + "</button>" +
          "<b data-qv>" + qtyOf(c) + "</b>" +
          '<button class="iconbtn iconbtn--sm" type="button" data-q="1" aria-label="One more">' + KD.icon("plus") + "</button></div></div>" +
        '<div class="field"><span class="label">Binders</span><div class="stack" data-binds></div></div>' +
        '<div class="cardx__actions">' + KD.cardx.buyBtn(c.name) +
          '<button class="btn btn--ghost btn--sm" type="button" data-todeck>' + KD.icon("layers") + "<span>Add to a deck</span></button>" +
          '<button class="btn btn--danger btn--sm" type="button" data-rm>' + KD.icon("trash") + "<span>Remove</span></button></div>" +
      "</div></div>"
    });
    KD.$$("[data-q]", s.el).forEach(function (b) {
      b.addEventListener("click", function () {
        var delta = parseInt(b.dataset.q, 10);
        chain = chain.then(async function () {
          var next = qtyOf(c) + delta;
          await D.setCollectionQty(c, next);
          changed = true;
          if (next <= 0) { s.close(); KD.toast("Removed " + c.name + " from your collection.", "ok"); }
          else KD.$("[data-qv]", s.el).textContent = next;
        }).catch(function (e) { console.error(e); KD.toast("That change didn't save. Try again.", "err"); });
      });
    });
    KD.$("[data-rm]", s.el).addEventListener("click", async function () {
      var n = qtyOf(c);
      var ok = await KD.confirm({ title: "Remove " + c.name + "?", body: "<p>This takes " + (n === 1 ? "it" : "all " + n + " copies") + " out of your collection. Your decks aren't affected.</p>", confirm: "Remove", danger: true });
      if (!ok) return;
      try { await D.setCollectionQty(c, 0); changed = true; s.close(); KD.toast("Removed " + c.name + ".", "ok"); }
      catch (e) { KD.toast("Couldn't remove it. Try again.", "err"); }
    });
    KD.$("[data-todeck]", s.el).addEventListener("click", function () { pickDeck(c); });

    function paintBinds() {
      var host = KD.$("[data-binds]", s.el);
      if (!host) return;
      var ids = new Set(c.binderIds || []);
      host.innerHTML = (S.binders.length
        ? S.binders.map(function (b) {
          return '<label class="check"><input type="checkbox" data-bind="' + esc(b.id) + '"' + (ids.has(b.id) ? " checked" : "") + "><span>" + esc(b.name) + "</span></label>";
        }).join("")
        : '<p class="hint">No binders yet. Binders group cards inside your collection, like a trade binder or a cube list.</p>') +
        '<div class="row"><input class="input input--sm" data-newbinder maxlength="40" placeholder="New binder name" aria-label="New binder name">' +
        '<button class="btn btn--ghost btn--sm" type="button" data-newbinder-go>' + KD.icon("plus") + "Add</button></div>";
      KD.$$("[data-bind]", host).forEach(function (cb) {
        cb.addEventListener("change", async function () {
          cb.disabled = true;
          try { await D.toggleCardBinder(c, cb.dataset.bind, cb.checked); changed = true; }
          catch (e) { cb.checked = !cb.checked; KD.toast("Couldn't update the binder.", "err"); }
          cb.disabled = false;
        });
      });
      var input = KD.$("[data-newbinder]", host), go = KD.$("[data-newbinder-go]", host);
      var create = async function () {
        var name = input.value.trim();
        if (!name) { input.focus(); return; }
        go.disabled = true;
        try {
          var id = await D.createBinder(name);
          await D.toggleCardBinder(c, id, true);
          changed = true;
          KD.toast("Filed in “" + name + "”.", "ok");
          paintBinds();
        } catch (e) { go.disabled = false; KD.toast(e.message || "Couldn't create the binder.", "err"); }
      };
      go.addEventListener("click", create);
      input.addEventListener("keydown", function (e) { if (e.key === "Enter") create(); });
    }
    paintBinds();
  }

  // Add one copy of a collection card to one of the user's decks.
  async function pickDeck(c) {
    var s = KD.sheet({ title: "Add to a deck", sub: esc(c.name), body: '<div class="actionlist" data-decks><div class="rskel skel"></div><div class="rskel skel"></div><div class="rskel skel"></div></div>' });
    try { await D.loadDecks(); } catch (e) { /* shown below */ }
    var host = KD.$("[data-decks]", s.el);
    if (!host) return;
    var decks = S.decks || [];
    if (!decks.length) {
      host.innerHTML = '<p class="hint">You don’t have any decks yet.</p><button class="btn btn--lure btn--sm mt-8" type="button" data-create>' + KD.icon("plus") + "New deck</button>";
      return;
    }
    host.innerHTML = decks.map(function (d) {
      return '<button type="button" data-deckpick="' + esc(d.id) + '">' + KD.icon("layers") + "<span>" + esc(d.name) +
        ' <small class="muted">· ' + esc(D.formatLabel(d.format)) + "</small></span></button>";
    }).join("");
    KD.$$("[data-deckpick]", host).forEach(function (b) {
      b.addEventListener("click", async function () {
        var d = decks.find(function (x) { return x.id === b.dataset.deckpick; });
        s.close();
        KD.busy("Adding to " + d.name + "…");
        try {
          var cards = await D.getDeckCards(d.id);
          if (cards.some(function (x) { return String(x.id).indexOf("inline-") === 0; })) {
            KD.idle();
            KD.toast("Open that deck once so it can update, then try again.", "info");
            return;
          }
          await D.addToDeck(d.id, cards, c);
          D.touchDeck(d.id);
          d.cardCount = cards.reduce(function (t, x) { return t + (parseInt(x.quantity, 10) || 1); }, 0);
          KD.idle();
          KD.toast("Added " + c.name + " to " + d.name + ".", "ok");
        } catch (e) { console.error(e); KD.idle(); KD.toast("Couldn't add it to that deck.", "err"); }
      });
    });
  }

  // ================================================================ add, import, export, clear

  function openAdd() {
    var changed = false, token = 0, timer = null, buf = [], shown = 0, next = null, cache = {}, chain = Promise.resolve();
    var s = KD.sheet({
      title: "Add to your collection", size: "lg",
      onClose: function () { if (changed && mounted()) paint(); },
      body: '<label class="inputwrap">' + KD.icon("search") +
          '<input class="input" type="search" data-aq placeholder="Search any card by name" autocomplete="off" spellcheck="false" enterkeyhint="search" autofocus aria-label="Search cards"></label>' +
        '<p class="hint mt-8">Tap + once for every copy you own. Got a long list? <button class="linkbtn" type="button" data-to-import>Import it instead</button>.</p>' +
        '<div class="results mt-16" data-ares aria-live="polite"></div>'
    });
    var input = KD.$("[data-aq]", s.el), box = KD.$("[data-ares]", s.el);
    KD.$("[data-to-import]", s.el).addEventListener("click", function () { s.close(); setTimeout(openImport, 120); });
    D.loadCollection().catch(function () {});

    function owned(name) { return (S.collection || []).filter(function (c) { return c.name === name; }).reduce(function (t, c) { return t + qtyOf(c); }, 0); }
    function row(c) {
      var face = (c.card_faces && c.card_faces[0]) || c, img = KD.safeUrl(D.artUrl(D.getCardImageUrl(c))), n = owned(c.name);
      return '<div class="rrow" data-sid="' + esc(c.id) + '">' +
        (img ? '<img class="rrow__thumb" src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '<span class="rrow__thumb"></span>') +
        '<div class="rrow__main"><div class="rrow__name"><span>' + esc(c.name) + '</span><b class="rrow__in" data-own="' + esc(c.name) + '"' + (n ? "" : " hidden") + ">" + n + " owned</b></div>" +
          '<div class="rrow__meta">' + KD.mana(String(c.mana_cost || face.mana_cost || "").split("//")[0]) + "<span>" + esc(String(c.type_line || "").split("//")[0].split("—")[0].trim()) + "</span>" +
          (c.prices && c.prices.usd ? '<span class="mono">$' + esc(c.prices.usd) + "</span>" : "") + "</div></div>" +
        '<button class="addbtn" type="button" data-add aria-label="Add a copy of ' + esc(c.name) + '">' + KD.icon("plus") + "</button></div>";
    }
    function render(n) {
      var old = KD.$("[data-more]", box); if (old) old.remove();
      var slice = buf.slice(shown, shown + n);
      slice.forEach(function (c) { cache[c.id] = c; });
      box.insertAdjacentHTML("beforeend", slice.map(row).join(""));
      shown += slice.length;
      if (shown < buf.length) box.insertAdjacentHTML("beforeend", '<button class="btn btn--ghost btn--sm btn--block mt-8" type="button" data-more>Show more</button>');
      else if (next) box.insertAdjacentHTML("beforeend", '<button class="btn btn--ghost btn--sm btn--block mt-8" type="button" data-more="page">Load more cards</button>');
    }
    async function run() {
      var q = input.value.trim(), my = ++token;
      if (!q) { box.innerHTML = ""; return; }
      box.innerHTML = new Array(6).join('<div class="rskel skel"></div>');
      try {
        var r = await D.scrySearch(q);
        if (my !== token) return;
        buf = r.data; next = r.next; shown = 0; cache = {};
        box.innerHTML = buf.length ? "" : '<div class="empty">' + KD.icon("search") + "<p>No cards match that.</p></div>";
        if (buf.length) render(40);
      } catch (e) {
        if (my !== token) return;
        box.innerHTML = '<div class="empty">' + KD.icon("alert") + "<p>" + (/Scryfall 400/.test(e.message || "") ? "Scryfall couldn't read that search." : "Search failed. Check your connection and try again.") + "</p></div>";
      }
    }
    input.addEventListener("input", function () { clearTimeout(timer); timer = setTimeout(run, 350); });
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); clearTimeout(timer); run(); if (KD.mobile()) input.blur(); } });
    box.addEventListener("click", async function (e) {
      var more = e.target.closest("[data-more]");
      if (more) {
        if (more.dataset.more !== "page") { render(40); return; }
        more.disabled = true; more.textContent = "Loading…";
        try { var r = await D.scryNext(next); buf = buf.concat(r.data); next = r.next; render(40); }
        catch (err) { more.disabled = false; more.textContent = "Couldn't load. Tap to retry"; }
        return;
      }
      var add = e.target.closest("[data-add]");
      if (!add) return;
      var sc = cache[add.closest("[data-sid]").dataset.sid];
      if (!sc) return;
      add.classList.add("is-done");
      add.innerHTML = KD.icon("check");
      clearTimeout(add._t);
      add._t = setTimeout(function () { add.classList.remove("is-done"); add.innerHTML = KD.icon("plus"); }, 900);
      // one write at a time, so tapping + three times really adds three copies
      chain = chain.then(async function () {
        await D.saveToCollection(sc, 1);
        changed = true;
        KD.$$("[data-own]", box).forEach(function (b) {
          if (b.dataset.own !== sc.name) return;
          var n = owned(sc.name);
          b.hidden = !n; b.textContent = n + " owned";
        });
      }).catch(function (err) { console.error(err); KD.toast("Couldn't add " + sc.name + ". Try again.", "err"); });
    });
  }

  function openImport() {
    var s = KD.sheet({
      title: "Import cards", sub: "Paste a list or upload a file. Cards you already have just get their counts raised.", size: "lg",
      body: '<div class="aiform">' +
        '<label class="field"><span class="label">Your cards</span><textarea class="textarea" data-itext style="min-height:220px" placeholder="4 Lightning Bolt&#10;2 Counterspell&#10;1 Sol Ring (C21) 263&#10;10 Island"></textarea></label>' +
        '<div class="row row--wrap"><label class="btn btn--ghost btn--sm">' + KD.icon("upload") + '<span>Upload a file</span><input type="file" data-ifile accept=".txt,.csv,.dec,text/plain,text/csv" hidden></label>' +
          '<span class="hint" data-ifname></span></div>' +
        "<details><summary>What can I paste?" + KD.icon("down") + '</summary><div class="aiform__adv">' +
          '<p class="hint">One card per line: how many, then the name. Set codes, collector numbers and foil marks are ignored, and CSV exports from Moxfield or Archidekt work as they are.</p>' +
          '<pre class="codebox">4 Lightning Bolt\n2x Counterspell\n1 Sol Ring (C21) 263\n1 Arcane Signet *F*\n10 Island</pre></div></details>' +
      "</div>",
      foot: '<button class="btn btn--ghost" type="button" data-close>Cancel</button><button class="btn btn--lure" type="button" data-igo>' + KD.icon("download") + "<span>Import</span></button>"
    });
    var ta = KD.$("[data-itext]", s.el);
    KD.$("[data-ifile]", s.el).addEventListener("change", function (e) {
      var f = e.target.files && e.target.files[0];
      if (!f) return;
      if (f.size > 4 * 1024 * 1024) { KD.toast("That file is too big. Try a text or CSV export.", "err"); return; }
      var rd = new FileReader();
      rd.onload = function () { ta.value = String(rd.result || ""); KD.$("[data-ifname]", s.el).textContent = f.name; };
      rd.onerror = function () { KD.toast("Couldn't read that file.", "err"); };
      rd.readAsText(f);
    });
    KD.$("[data-igo]", s.el).addEventListener("click", function () {
      var parsed = D.parseListText(ta.value);
      if (!parsed.entries.length) { ta.focus(); KD.toast("No cards found. Check the format and try again.", "info"); return; }
      s.close();
      runImport(parsed);
    });
    setTimeout(function () { if (!KD.mobile()) ta.focus(); }, 80);
  }

  async function runImport(parsed) {
    KD.busy("Matching " + parsed.entries.length + " " + KD.plural(parsed.entries.length, "line") + "…");
    var res;
    try {
      await D.loadCollection();
      var r = await D.resolveCardNames(parsed.entries.map(function (e) { return e.name; }), function (done, total) {
        KD.busyText("Matching card names… " + done + " of " + total);
      });
      KD.busyText("Saving to your collection…");
      res = await D.importCollection(parsed.entries, r.resolved);
    } catch (e) {
      console.error("collection import", e);
      KD.idle();
      KD.toast("The import failed while saving, so your collection may be partly updated. Try again.", "err");
      try { await D.loadCollection(true); } catch (err) { /* ignore */ }
      paint();
      return;
    }
    KD.idle();
    paint();
    KD.importReport({ what: "your collection", matchedLines: res.matchedLines, totalLines: parsed.entries.length, importedQty: res.importedQty, unmatchedLines: res.unmatchedLines, skipped: parsed.skipped });
  }

  function moreMenu(anchor) {
    var has = (S.collection || []).length > 0;
    var items = [{ label: "Manage binders", icon: "folder", onClick: openBinders }];
    if (has) {
      items.push(
        { label: "Download as .txt", icon: "download", onClick: exportList },
        { label: "Copy card list", icon: "copy", onClick: function () { KD.copy(listText(), "Card list copied."); } },
        "sep",
        { label: "Clear collection", icon: "trash", danger: true, onClick: clearFlow });
    }
    KD.menu(anchor, items, "Collection");
  }
  function listText() {
    return (S.collection || []).slice().sort(nameCmp).map(function (c) { return qtyOf(c) + " " + c.name; }).join("\n");
  }
  function exportList() { KD.download("krakenthemeta-collection.txt", listText() + "\n"); }

  async function clearFlow() {
    var t = D.collectionTotals();
    if (!t.unique) { KD.toast("Your collection is already empty.", "info"); return; }
    var ok = await KD.confirm({
      title: "Clear your whole collection?",
      body: "<p>This deletes all <b>" + KD.fmt(t.cards) + " cards</b> (" + KD.fmt(t.unique) + " unique) and their binder filing. Your decks aren't affected.</p><p><b>This can't be undone.</b></p>",
      confirm: "Delete my collection", danger: true, typeToConfirm: "DELETE"
    });
    if (!ok) return;
    KD.busy("Clearing your collection…");
    try {
      var r = await D.clearCollection(function (done, total) { KD.busyText("Clearing your collection… " + done + " of " + total); });
      KD.idle();
      paint();
      KD.toast("Collection cleared: " + KD.fmt(r.totalQty) + " " + KD.plural(r.totalQty, "card") + " deleted.", "ok");
    } catch (e) {
      console.error(e);
      KD.idle();
      try { await D.loadCollection(true); } catch (err) { /* ignore */ }
      paint();
      KD.toast("Clearing stopped partway. What's left is shown here; try again.", "err");
    }
  }

  // ================================================================ binders

  function openBinders() {
    var s = KD.sheet({
      title: "Binders",
      sub: "Named groups inside your collection. A card can sit in several binders, and deleting a binder never deletes cards.",
      onClose: function () { paint(); },
      body: "<div data-blist></div>"
    });
    function render() {
      var host = KD.$("[data-blist]", s.el);
      if (!host) return;
      host.innerHTML = (S.binders.length ? '<div class="stack">' + S.binders.map(function (b) {
        var n = copiesIn(b.id);
        return '<div class="brow" data-bid="' + esc(b.id) + '">' + KD.icon("folder") +
          '<input class="input input--sm" value="' + esc(b.name) + '" maxlength="40" aria-label="Binder name">' +
          '<span class="brow__n">' + KD.fmt(n) + " " + KD.plural(n, "card") + "</span>" +
          '<button class="iconbtn iconbtn--sm" type="button" data-bsave aria-label="Save name" title="Save name">' + KD.icon("check") + "</button>" +
          '<button class="iconbtn iconbtn--sm" type="button" data-bdel aria-label="Delete binder" title="Delete binder">' + KD.icon("trash") + "</button></div>";
      }).join("") + "</div>" : '<div class="empty" style="padding:18px 10px">' + KD.icon("folder") + "<p>No binders yet.</p></div>") +
        '<div class="field mt-16"><span class="label">New binder</span><div class="row"><input class="input input--sm" data-bnew maxlength="40" placeholder="Trade binder, cube, Standard pool…" aria-label="New binder name">' +
        '<button class="btn btn--lure btn--sm" type="button" data-bcreate>' + KD.icon("plus") + "Create</button></div></div>";
      KD.$$("[data-bid]", host).forEach(function (row) {
        var id = row.dataset.bid, input = KD.$("input", row);
        var save = async function () {
          try { await D.renameBinder(id, input.value); KD.toast("Binder renamed.", "ok"); render(); }
          catch (e) { KD.toast(e.message || "Rename failed.", "err"); }
        };
        KD.$("[data-bsave]", row).addEventListener("click", save);
        input.addEventListener("keydown", function (e) { if (e.key === "Enter") save(); });
        KD.$("[data-bdel]", row).addEventListener("click", async function () {
          var b = S.binders.find(function (x) { return x.id === id; });
          var ok = await KD.confirm({ title: "Delete “" + (b ? b.name : "this binder") + "”?", body: "<p>The binder goes away. Its cards stay in your collection.</p>", confirm: "Delete binder", danger: true });
          if (!ok) return;
          try { await D.deleteBinder(id); if (st.binder === id) st.binder = ""; KD.toast("Binder deleted. Its cards are still in your collection.", "ok"); render(); }
          catch (e) { KD.toast("Couldn't delete the binder.", "err"); }
        });
      });
      var nb = KD.$("[data-bnew]", host), go = KD.$("[data-bcreate]", host);
      var create = async function () {
        if (!nb.value.trim()) { nb.focus(); return; }
        go.disabled = true;
        try { await D.createBinder(nb.value); KD.toast("Binder created. Open a card to file it there.", "ok"); render(); }
        catch (e) { go.disabled = false; KD.toast(e.message || "Couldn't create the binder.", "err"); }
      };
      go.addEventListener("click", create);
      nb.addEventListener("keydown", function (e) { if (e.key === "Enter") create(); });
    }
    D.loadCollection().then(render, render);
  }
})();
